import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, requiresAccess = false }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="animate-pulse text-slate-500 text-sm">Wird geladen...</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (requiresAccess && !user.has_access) return <Navigate to="/paywall" replace />;
  return children;
}
